import { CrudBuilderState } from "seneca-common/utils/apiStates";

import MemoriesStateSlice from "../../models/MemoriesStateSlice";
import { Memories } from "../../models/state/memories/Memories";

export function getMemoriesSlice(state: MemoriesStateSlice): Memories {
  return state.memories;
}

export function getMetaSlice(state: MemoriesStateSlice): CrudBuilderState {
  return state.meta as CrudBuilderState;
}
